<template>
    <div>
        <!-- Table -->
        <b-table
            id="studentsTable"
            :items="table"
            :fields="fields"
            empty-text="Não encontramos nenhum resultado na busca :("
            class="bg-white mb-0"
            stacked="md"
            :sticky-header="true"
            show-empty
            bordered
            hover>

        </b-table>
    </div>
</template>

<script>
export default {
    props: {
        table: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            fields: [
                { key: 'name', label: 'Aluno', sortable: true },
                { key: 'essays_sent', label: 'Qtd. de Redações Enviadas', sortable: true },
            ],
        }
    }
}
</script>

<style scoped>

</style>
